import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
} from "@/components/ui/sidebar";
import { NavMain } from "./components/NavMain";
import { NavResources } from "./components/NavResources";
import { NavSecondary } from "./components/NavSecondary";
import { OrganizationLogo } from "./components/OrganizationLogo";
import { SECONDARY_NAV } from "./frontend-routes";

// Override sidebar CSS variables so bg-sidebar resolves to the light surface palette.
const frontendSidebarVars = {
    "--sidebar": "var(--background)",
    "--sidebar-foreground": "var(--foreground)",
    "--sidebar-accent": "oklch(0.95 0.03 266.27)",
    "--sidebar-accent-foreground": "var(--primary)",
    "--sidebar-border": "var(--border)",
    "--sidebar-ring": "var(--ring)",
    "--sidebar-primary": "var(--primary)",
    "--sidebar-primary-foreground": "var(--primary-foreground)",
} as React.CSSProperties;

export const FrontEndSideNav = () => {
    return (
        <div style={frontendSidebarVars}>
            <Sidebar
                className="top-(--top-offset) h-[calc(100svh-var(--top-offset))]!"
                collapsible="offcanvas"
                side="left"
            >
                <SidebarContent>
                    <NavMain />
                    <NavResources />
                    <NavSecondary items={SECONDARY_NAV} className="mt-auto" />
                </SidebarContent>
                <SidebarFooter className="flex items-center px-3 pb-4">
                    <OrganizationLogo />
                </SidebarFooter>
            </Sidebar>
        </div>
    );
};
